"use client";

import { withCn } from "@udecode/cn";
import { PlateElement } from "@udecode/plate-common";

export const ParagraphElement = withCn(PlateElement);
